module.exports = __webpack_public_path__ + "static/media/empty_add.b17d7e2d.svg";